import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/about-section1.css";
import aboutImg from "../../assets/all-images/slider-img/slider-1.jpg";
import { motion } from "framer-motion";

const AboutSection1 = () => {
  const t = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section className="about-section">
      <div className="section-bg-pattern"></div>
      <Container>
        <Row className="align-items-center">
          <Col lg="7" md="7" className="order-md-1 order-2">
            <motion.div
              className="about-content"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={containerVariants}
            >
              <motion.h4 className="section-subtitle" variants={itemVariants}>
                {t("about.subtitle")}
              </motion.h4>
              <motion.h2 className="section-title" variants={itemVariants}>
                {t("about.title")}
              </motion.h2>
              <motion.p className="section-description" variants={itemVariants}>
                {t("about.seconddescription")}
              </motion.p>

              <motion.div className="features-grid" variants={itemVariants}>
                {[1, 2, 3, 4].map((item) => (
                  <motion.div
                    key={item}
                    className="feature-card"
                    whileHover={{ y: -5 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <div className="feature-icon">
                      <i className="ri-checkbox-circle-line"></i>
                    </div>
                    <p>{t(`about.feature1${item}`)}</p>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </Col>

          <Col lg="5" md="5" className="order-md-2 order-1 mb-4 mb-md-0">
            <motion.div
              className="about-image-container"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="image-frame">
                <img
                  src={aboutImg}
                  alt={t("about.imageAlt")}
                  className="about-image"
                />
                {/* <div className="experience-badgee">
                  <div className="badge-content">
s                    <h5>{t("about.secondpicturetag")}</h5>
                  </div>
                  <div className="badge-particles">
                    {[...Array(8)].map((_, i) => (
                      <span key={i} className="particle"></span>
                    ))}
                  </div>
                </div> */}
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection1;
